export const courseCardSx = {
  container: {
    cursor: 'pointer',
    mr: { xs: 0, sm: 3 },
  },
  imageBox: {
    borderRadius: '15px',
    aspectRatio: '16 / 9',
    width: { xs: 'auto', sm: 300 },
    height: { xs: 'auto', sm: 180 },
  },
  skeleton: {
    borderRadius: '15px',
    aspectRatio: '16/9',
  },
  detailsBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  categoryText: {
    color: 'grey',
    fontWeight: '400',
    p: 0,
    fontSize: '12px',
    textTransform: 'uppercase'
  },
  titleText: {
    wordBreak: 'break-word',
    fontSize: { xs: '18px', sm: '24px' },
    fontWeight: 600,
    textTransform: 'capitalize'
  },
  costBox: {
    minWidth: '100px'
  },
  costText: {
    wordBreak: 'break-word',
    fontSize: '24px',
    fontWeight: 600,
    textTransform: 'capitalize'
  },
  subTitleText: {
    fontWeight: '500',
    wordBreak: 'break-word',
    fontSize: '16px',
    textTransform: 'capitalize'
  },
  educatorText: {
    fontWeight: '400',
    wordBreak: 'break-word',
    fontSize: '14px',
    textTransform: 'capitalize'
  },
  ratingsBox: {
    alignItems: 'center',
    gap: 1
  },
  starsText: {
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'capitalize'
  },
  reviewsText: {
    fontWeight: 600,
    wordBreak: 'break-word',
    fontSize: '16px',
    textTransform: 'capitalize'
  },
  divider: {
    width: '100%',
    border: '1px solid lightgray'
  }
};
